import React from 'react';
import { useChartColors } from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import { useEmployeeEngagementDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/store/employeeEngagement.store';
import {
  HorizontalBarChart,
  HorizontalBarItem,
} from 'pages/ReportsPage/components/AnalyticsDashboards/OverviewDashboard/HorizontalBarChart';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/EmployeeEngagementDashboard/EmployeeEngagementDashboard.styled';

export const HoursWorkedChart: React.FC = () => {
  const data = useEmployeeEngagementDashboardStore((s) => s.hoursWorked);
  const page = useEmployeeEngagementDashboardStore((s) => s.hoursWorkedPage);
  const totalPages = useEmployeeEngagementDashboardStore((s) => s.hoursWorkedTotalPages);
  const loadingMore = useEmployeeEngagementDashboardStore((s) => s.hoursWorkedLoadingMore);
  const loadMore = useEmployeeEngagementDashboardStore((s) => s.loadMoreHoursWorked);
  const palette = useChartColors();

  if (!data || data.length === 0) {
    return <EmptyStateContainer>No data available</EmptyStateContainer>;
  }

  const barColor = palette.chartColors[3];

  const items: HorizontalBarItem[] = data.map((d) => ({
    label: d.teamMember,
    value: d.hoursWorked,
    valueLabel: `${d.hoursWorked}`,
    ariaLabel: `${d.teamMember}: ${d.hoursWorked} hours worked`,
    tooltipHtml: `<strong>${d.teamMember}</strong><br/>Hours Worked: ${d.hoursWorked}`,
    barColor,
  }));

  return (
    <HorizontalBarChart
      items={items}
      rightMargin={60}
      scrollable
      ariaLabel="Hours worked by team member chart"
      onLoadMore={loadMore}
      hasMore={page < totalPages}
      isLoadingMore={loadingMore}
    />
  );
};
